var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.966,
    height: 12.57,
    viewBox: "0 0 15.966 12.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-983.63 -559.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M999.6,570a4.64,4.64,0,0,1-.335.793,1.715,1.715,0,0,1-1.539.783c-1.122-.005-2.244,0-3.366,0q-4.411,0-8.821,0a1.839,1.839,0,0,1-1.658-.9,1.727,1.727,0,0,1-.246-.951q0-2.291,0-4.582c0-.966,0-1.933,0-2.9a1.806,1.806,0,0,1,1.411-1.767,2.323,2.323,0,0,1,.479-.045c.738,0,1.475,0,2.213,0h.154a3.818,3.818,0,0,1,.179-.619,1.361,1.361,0,0,1,1.316-.8c1.486,0,2.972-.009,4.457,0a1.37,1.37,0,0,1,1.4,1.061,3.528,3.528,0,0,1,.058.359h.163c.753,0,1.507,0,2.26,0a1.8,1.8,0,0,1,1.853,1.515.136.136,0,0,0,.024.038Zm-7.981.772q3.024,0,6.047,0a1.5,1.5,0,0,0,.4-.042,1.006,1.006,0,0,0,.745-1.074q.009-3.678,0-7.356a1.209,1.209,0,0,0-.1-.5.96.96,0,0,0-.945-.562h-2.774c-.344,0-.5-.157-.5-.505,0-.078,0-.156,0-.234,0-.494-.206-.7-.7-.7h-4.317c-.057,0-.114,0-.171,0a.547.547,0,0,0-.521.507c-.013.144-.009.29-.011.436a.435.435,0,0,1-.5.492c-.93,0-1.86,0-2.79,0a.974.974,0,0,0-1.032,1.009q-.006,3.756,0,7.512a1.083,1.083,0,0,0,.1.449.987.987,0,0,0,.978.561Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1080.625,631.583a3.732,3.732,0,1,1-3.714-3.743A3.738,3.738,0,0,1,1080.625,631.583Zm-.824.02a2.91,2.91,0,1,0-2.911,2.9A2.9,2.9,0,0,0,1079.8,631.6Z",
    transform: "translate(-85.277 -65.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1250.479,629.009a.739.739,0,1,1,.742-.742A.741.741,0,0,1,1250.479,629.009Z",
    transform: "translate(-253.464 -65.269)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7f1f80421eb0a07f3de5291225f98c9c.svg";
export { ForwardRef as ReactComponent };